module.exports = __webpack_public_path__ + "static/Dona-Medium-fc313d4bbb39fdd6fb97f93ca3120247.woff2";